const $ = window.jQuery;
import Splide from "@splidejs/splide";

$(function () {
	let quote_slider = document.querySelectorAll(".aka-block-text-slider .background-image");
	if (quote_slider.length > 0) {
		for (let i = 0; i < quote_slider.length; i++) {
			let quote_sliderElement = quote_slider[i];
			let quote_sliderDefaultOptions = {
				type: "fade",
				arrows: false,
				pagination: false,
				trimSpace: false,
				perPage: 1,
                perMove: 1,
				autoplay: true,
				rewind: true,
  				interval: 4000
			};
			let quotes = new Splide(quote_sliderElement, quote_sliderDefaultOptions);
			quotes.mount();
		}


		function setBlockHeights() {
			if (window.innerWidth > 1024) {
				let slides = document.querySelectorAll('.aka-block-text-slider .splide__slide');
				let article = document.querySelector('.aka-block-text-slider .content-editor');
				
				slides.forEach(function(slide) {
					if (article) {
						let articleHeight = article.offsetHeight;
						slide.style.height = (articleHeight + 200) + 'px';
					}
				});
			} else {
				// Optional: Reset heights or do nothing
			}
		}		

		
		setBlockHeights();
		window.addEventListener('resize', setBlockHeights);

	}


});
